module.exports = __webpack_public_path__ + "img/small-vkontakte.ce480afb.svg";